module.exports = __webpack_public_path__ + "static/img/truCOLOR-porcelain-enamel-sign16.0af3806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/trucolor/truCOLOR-porcelain-enamel-sign16.jpg
// module id = 855
// module chunks = 0